'use strict';

export default {}